export const dominoItemsFirstRow = [
  { prop: "lda_score", label: "LDA Score" },
  {
    prop: "numberdonor_numbersynonymous",
    label: "Number Donor / Number Synonymous",
  },
  { prop: "mrna_half_life", label: "mRNA Half-life" },
];

export const dominoItemsSecondRow = [
  { prop: "string_combined_score", label: "STRING Combined Score" },
  {
    prop: "string_experimental_score",
    label: "STRING Experimental Score",
  },
  { prop: "string_text_mining_score", label: "STRING Text Mining Score" },
  { prop: "phylop_at_5_prime_utr", label: "Phylop at 5' UTR" },
];
